<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Send Proposal'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>
    <ng-container *ngIf="loaded">

      <tidy-row [align]="'center'">
        <tidy-text
          [body]="'Email a beautiful proposal to your Client so they can agree with 1 tap. '">
        </tidy-text>
        <tidy-text
          (action)="learnMore()"
          [body]="'Learn More'"
          class="link">
        </tidy-text>
      </tidy-row>

      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="field-bottom-padding" [alignLastItemRight]="true">
            <tidy-image
              [src]="'assets/svg/person-circle.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Send Proposal to'">
            </tidy-text>
            <tidy-select
              [items]="[
                {
                  viewValue: 'Existing Client',
                  value: 'existing'
                },
                {
                  viewValue: 'New Client',
                  value: 'new'
                }
              ]"
              formControlName="clientOptions"
              [form]="form.controls.clientOptions"
              (optionChange)="changeClientOption($event)"
              style="width:20px">
            </tidy-select>
          </tidy-row>

          <ng-container *ngIf="!addingNewClient">

            <tidy-row *ngIf="!clientItems?.length">
              <tidy-text
                [body]="'You don\'t have any existing Clients.'">
              </tidy-text>
            </tidy-row>

            <ng-container *ngIf="clientItems?.length">
              <tidy-row [ngClass]="(clientSelected && (addressItems?.length > 2 || addresses?.length == 0)) ? 'field-bottom-padding' : ''">
                <tidy-auto-complete
                  [showGoogleIcon]="false"
                  formControlName="client"
                  [options]="clientItems"
                  [form]="form.controls.client"
                  [selected]="selectedClient"
                  [icon]="'assets/svg/search.svg'"
                  [isToSearchBetweenOptions]="true"
                  (action)="selectClient($event)"
                  [submitted]="submitted"
                  [label]="'Choose Client'"
                  [errorMessage]="'Please select a Client from your list.'">
                </tidy-auto-complete>
              </tidy-row>

              <tidy-row *ngIf="clientSelected && addressItems?.length > 2">
                <tidy-select
                  [label]="'Proposal Valid at '"
                  [form]="form.controls.currentClientAddress"
                  [icon]="'assets/svg/home-outline.svg'"
                  formControlName="currentClientAddress"
                  [items]="addressItems"
                  (optionChange)="selectAddress($event)">
                </tidy-select>
              </tidy-row>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="addingNewClient">
            <tidy-row class="field-bottom-padding">
              <tidy-input
                [label]="'First Name'"
                formControlName="firstName"
                data-cy="firstName"
                [form]="form.controls.firstName"
                [icon]="'assets/svg/person-circle-outline.svg'"
                [activeIcon]="'assets/svg/person-circle-outline-tidy-green.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter the client\'s first name'">
              </tidy-input>
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-input
                [label]="'Last Name'"
                formControlName="lastName"
                data-cy="lastName"
                [form]="form.controls.lastName"
                [icon]="'assets/svg/person-circle-outline.svg'"
                [activeIcon]="'assets/svg/person-circle-outline-tidy-green.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter the client\'s last name'">
              </tidy-input>
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-input
                [label]="'Email'"
                formControlName="email"
                data-cy="email"
                type="email"
                [form]="form.controls.email"
                [icon]="'assets/svg/mail-outline.svg'"
                [activeIcon]="'assets/svg/mail-outline-tidy-green.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid email'">
              </tidy-input>
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-input-international-phone
                formControlName="phone"
                [label]="'Phone Number'"
                data-cy="phone"
                [form]="form.controls.phone"
                [inputMode]="'numeric'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid phone number.'"
                [icon]="'assets/svg/phone-portrait-outline.svg'"
                [defaultCountryCode]="countryCode"
                [activeIcon]="'assets/svg/phone-portrait-outline-tidy-green.svg'"
                [initialMask]="countryCode || 'US'">
              </tidy-input-international-phone>
            </tidy-row>
          </ng-container>
          <ng-container *ngIf="addingNewClient || addresses?.length == 0">
            <tidy-row class="field-bottom-padding">
              <tidy-auto-complete-address
              [submitted]="submitted"
              [addressFormControl]="form.controls.address"
              [countryCode]="countryCode"
              (onAddressChosen)="choseItem($event)"
              (onError)="errorMessage = $event"
              (noAddressPickedUpdate)="noAddressPickedTemplate = $event"
              (invalidAddressError)="invalidAddressError = $event">
            </tidy-auto-complete-address>
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-input
                [label]="'Unit / Suite'"
                formControlName="unit"
                data-cy="unit"
                [form]="form.controls.unit"
                [icon]="'assets/svg/home-outline.svg'"
                [activeIcon]="'assets/svg/home-outline-tidy-green.svg'">
              </tidy-input>
            </tidy-row>
            <tidy-row>
              <tidy-input
                [customMask]="zipCodeMask"
                [label]="'Zipcode'"
                formControlName="zip"
                [inputMode]="'numeric'"
                data-cy="zipcode"
                [form]="form.controls.zip"
                [icon]="'assets/svg/home-outline.svg'"
                [activeIcon]="'assets/svg/home-outline-tidy-green.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a valid zip code'">
              </tidy-input>
            </tidy-row>
          </ng-container>
          <tidy-row *ngIf="clientIsMissingEmail" style="padding-top:32px">
            <tidy-input
              [label]="'Email'"
              formControlName="email"
              data-cy="email"
              type="email"
              [form]="form.controls.email"
              [icon]="'assets/svg/mail-outline.svg'"
              [activeIcon]="'assets/svg/mail-outline-tidy-green.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid email'">
            </tidy-input>
          </tidy-row>
        </form>
      </tidy-card>

      <ng-container *ngTemplateOutlet="noAddressPickedTemplate">
      </ng-container>

      <tidy-card>
        <form [formGroup]="form">
          <tidy-row class="field-bottom-padding vertical-align-center">
            <tidy-image class="body-size"
              [src]="'assets/svg/information-circle.svg'"
              class="header-size">
            </tidy-image>
            <tidy-text
              [header]="'Service Detail'">
            </tidy-text>
          </tidy-row>

          <tidy-row [ngClass]="selectedService ? 'field-bottom-padding' : ''">
            <tidy-select
              [label]="'Service Type'"
              [form]="form.controls.service"
              formControlName="service"
              [icon]="'assets/svg/time-outline.svg'"
              [items]="serviceItems"
              (optionChange)="selectService($event)"
              [submitted]="submitted"
              [errorMessage]="'Please select a service type.'">
            </tidy-select>
          </tidy-row>

          <ng-container *ngIf="selectedService">
            <tidy-row class="field-bottom-padding">
              <tidy-textarea
                [label]="'Service Description'"
                [icon]="'assets/svg/information-circle-outline.svg'"
                formControlName="description"
                [form]="form.controls.description"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description.'">
              </tidy-textarea>
            </tidy-row>

            <tidy-row>
              <tidy-input
                [label]="'Service Price'"
                [icon]="'assets/svg/cash-outline.svg'"
                inputMode="numeric"
                [mask]="'currencyMask'"
                [type]="'text'"
                formControlName="price"
                [form]="form.controls.price"
                [submitted]="submitted"
                [errorMessage]="'Please enter a price.'">
              </tidy-input>
            </tidy-row>
          </ng-container>
        </form>
      </tidy-card>

      <tidy-error-message
        [text]="errorMessage">
      </tidy-error-message>

      <tidy-button
        [action]="sendProposal.bind(this)"
        [text]="'Send Proposal'"
        class="primary">
      </tidy-button>

    </ng-container>

    <ng-container *ngIf="!loaded">

      <tidy-row>
        <ion-skeleton-text animated style="width: 100%; margin: auto"></ion-skeleton-text><br>
        <ion-skeleton-text animated style="width: 240px; margin: auto"></ion-skeleton-text>
      </tidy-row>

      <tidy-card>
        <tidy-row class="field-bottom-padding">
          <tidy-grid>
            <ion-row>
              <ion-col size="5">
                <ion-skeleton-text animated style="width: 140px;  height: 20px"></ion-skeleton-text>
              </ion-col>
              <ion-col size="7">
                <ion-skeleton-text animated style="width: 105px; float: right"></ion-skeleton-text>
              </ion-col>
            </ion-row>
          </tidy-grid>
        </tidy-row>
        <tidy-row class="field-top-padding">
          <ion-skeleton-text animated style="width: 140px; margin-bottom: 5px"></ion-skeleton-text>
          <tidy-divider></tidy-divider>
        </tidy-row>
      </tidy-card>

      <tidy-card>
        <tidy-row class="field-bottom-padding">
          <ion-skeleton-text animated style="width: 140px;  height: 20px"></ion-skeleton-text>
        </tidy-row>
        <tidy-row class="field-top-padding">
          <ion-skeleton-text animated style="width: 140px; margin-bottom: 5px"></ion-skeleton-text>
          <tidy-divider></tidy-divider>
        </tidy-row>
      </tidy-card>

      <tidy-row>
        <ion-skeleton-text animated style="height: 70px"></ion-skeleton-text>
      </tidy-row>

    </ng-container>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
